module.exports = __webpack_public_path__ + "assets/background-eafff2496610eb8284c6253b5cafa7b9.png";